import { useContext, useState } from 'react';

import ModalTemplate from '../../../common/ModalTemplate';
import { Context } from '../../Provider';
import OtpSubmit from './components/OtpSubmit';
import PhoneNumberSubmit from './components/PhoneNumberSubmit';
import EmailAddressSubmit from './components/EmailAddressSubmit';

const Otp = ({ show, handleClose }) => {
    const [showEdit, setShowEdit] = useState(false);
    const [newDetails, setNewDetails] = useState({
        email: null,
        phoneNumber: null,
    });

    const { state } = useContext(Context);
    const { ftm, step } = state;

    const isPhoneStep = step?.stepId === 1;

    const handleCloseEdit = () => setShowEdit(false);

    const renderBody = () => {
        if (showEdit) {
            const SubmitComponent = isPhoneStep ? PhoneNumberSubmit : EmailAddressSubmit;
            return (
                <SubmitComponent
                    ftm_id={ftm?.ftm_id}
                    handleCloseEdit={handleCloseEdit}
                    newDetails={newDetails}
                    setNewDetails={setNewDetails}
                />
            );
        }

        return (
            <OtpSubmit
                ftm_id={ftm?.ftm_id}
                show={show}
                handleClose={handleClose}
                showEdit={showEdit}
                setShowEdit={setShowEdit}
                newDetails={newDetails}
            />
        );
    };

    return (
        <ModalTemplate
            show={show}
            handleClose={handleClose}
            size={null}
            centered
            title={null}
            backdrop="static"
            keyboard={false}
            body={renderBody()}
            footer={null}
        />
    );
};

export default Otp;